module.exports = __webpack_public_path__ + "static/media/sayap-header.857a1123.jpeg";